import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import ReactECharts from 'echarts-for-react';

import { OdometerConsumptionBaseDataDto } from '@/_generatedApi';
import { ElectricityDashboardsFilter } from '@/components/ui/filters/ElectricityDashboardFilters';
import formatDate, {
  consumptionUnitsFormat,
  prettyFormatNumber,
} from '@/utils/format';

const ElectricityIncrementalConsumptionGraph: FC<{
  filter: ElectricityDashboardsFilter;
  data: OdometerConsumptionBaseDataDto[];
}> = ({ filter, data }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const axisX = data.map((item) =>
    formatDate(
      new Date(item.fromDate),
      consumptionUnitsFormat[filter.consumptionUnit || '1 month'],
      i18n.language
    )
  );

  const incrementalValues = data.map((_, index) =>
    data.slice(0, index + 1).reduce((a, b) => a + b.value, 0)
  );

  const option = {
    grid: { top: 40, right: 10, bottom: 60, left: 60 },

    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    xAxis: [
      {
        type: 'category',
        data: axisX,
        name: 'h',
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'kWh',
        position: 'left',
        axisLabel: {
          formatter: (value: number) =>
            prettyFormatNumber(value, i18n.language),
        },
      },
    ],

    dataZoom: [
      {
        type: 'slider',
        height: 20,
        bottom: 10,
      },
    ],
    series: [
      {
        type: 'line',
        zlevel: 3,
        emphasis: {
          focus: 'series',
        },
        name: t('dashboardPage.currentYearValue'),
        itemStyle: { color: theme.palette.yellow.main },
        data: incrementalValues,
      },
    ],
  };

  return (
    <ReactECharts style={{ height: 250, width: '100%' }} option={option} />
  );
};

export default ElectricityIncrementalConsumptionGraph;
